import React, { Fragment, FunctionComponent } from 'react';
import { Divider } from '@mui/material';

import { hasNewLayoutModeFeatureFlag, UpgradeMenuItems } from '@paragon/login-tools';

import { showUpgradeAccountDialog } from '../../../../store/actions/popupActions';
import { InsertableObject } from '../../../../store/selectors/insertableObjectsSelector';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { AdditionalLoadsFlyout } from './AdditionalLoadsFlyout';
import { InsertableObjectMenuItem } from './InsertableObjectMenuItem';

export const InsertableObjectMenuItems: FunctionComponent<{
  monitorText: string;
  onChooseItem: () => void;
  insert: (obj: InsertableObject) => void;
  insertableObjects: readonly InsertableObject[];
}> = ({ monitorText, onChooseItem, insert, insertableObjects }) => {
  const dispatch = useAppDispatch();
  const hasLayoutFeatureFlag = useAppSelector(hasNewLayoutModeFeatureFlag);

  return (
    <UpgradeMenuItems
      active={!hasLayoutFeatureFlag}
      briefDescription="create layouts"
      onUpgradeClick={() => dispatch(showUpgradeAccountDialog())}
    >
      {insertableObjects.map((obj) => (
        <Fragment key={obj.name}>
          {obj.dividerBefore && <Divider />}
          {obj.name === 'Additional Loads' ? (
            <AdditionalLoadsFlyout
              monitorText={monitorText}
              onChooseItem={onChooseItem}
              disabled={obj.disabled ?? false}
            />
          ) : (
            <InsertableObjectMenuItem obj={obj} onClick={() => insert(obj)} />
          )}
        </Fragment>
      ))}
    </UpgradeMenuItems>
  );
};
